import z from 'zod';
export const paymentReferenceValue = z.object({
    value: z.string().trim().min(1),
});
export const createPaymentReference = (value) => paymentReferenceValue.parse(typeof value === 'string' ? { value } : value);
export const isPaymentReference = (value) => paymentReferenceValue.safeParse(value).success;
//# sourceMappingURL=payment-reference.js.map